import axios from "axios";

export const getPaymentUrl = async (serviceType, token) => {
  return await axios.post("https://ironglassbyte.com:5000/payments/checkout", {
    serviceType,
    token,
  });
};
